import { Flex, Spin } from 'antd';

import { ru } from '@/i18n/ru';

export function FullScreenSpin() {
  return (
    <Flex align="center" justify="center" style={{ minHeight: '100vh' }}>
      <Spin size="large" tip={ru.app.loading}>
        <div style={{ width: 120, height: 80 }} />
      </Spin>
    </Flex>
  );
}
